<template>
  <v-layout wrap>
    <template v-for="({ text, value }, idx) in items">
      <v-flex
        :key="'t' + idx"
        xs6
        class="text-end pa-3 grey lighten-4 primary--text"
      >
        <b>{{ text }}</b>
      </v-flex>
      <v-flex :key="'v' + idx" xs6 class="pa-3">
        {{ value }}
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
export default {
  name: 'ConfirmInputData',
  props: {
    questions: {
      type: Array,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      let form = this.form
      return [
        { text: '年齢', value: form.age },
        { text: '性別', value: form.gender },

        ...this.questions.filter(x => x.isActive).map(this.getAnswer),
        { text: '名前', value: `${form.familyName} ${form.givenName}` },
        {
          text: 'ふりがな',
          value: `${form.familyNameKana} ${form.givenNameKana}`,
        },
        {
          text: '住所',
          value: `${form.postcode} ${form.prefecture} ${form.city} ${form.address} ${form.building}`,
        },
        // { text: '携帯電話番号', value: form.phoneNumber },
        { text: '誕生日', value: form.birthday },
        // { text: 'メールアドレス', value: form.email },
        {
          text: 'お知らせを受け取る',
          value: form.receivesInfo ? '受け取る' : '受け取らない',
        },
      ]
    },
  },
  methods: {
    getAnswer(question) {
      let { id, shortText, options } = question
      let answers = this.form.counselingAnswers.filter(x => x.question === id)
      return {
        text: shortText,
        value: answers
          .map(({ option, text }) => {
            let opt = options.find(x => x.id === option)
            if (!opt) return null
            if (text) return `${opt.text}（${text}）`
            return opt.text
          })
          .filter(x => x)
          .join('、 '),
      }
    },
  },
}
</script>
